import { RecommendedArticleComponentProps } from '../types'
import React from 'react'
import {
  ArticlePdfIconContentSeparator,
  UseCaseComponentWrapper,
  UseCaseContentWrapper,
  UseCaseMedia,
  UseCaseMediaWrapper,
} from './styled'
import { RecommendedArticleItemCategory, RecommendedArticleItemTitle } from '../styled'

export const UseCaseItem = ({
  isSmall,
  isYoutube,
  src,
  alt,
  category,
  to,
  title,
  component,
}: RecommendedArticleComponentProps) => (
  <UseCaseComponentWrapper $isSmall={isSmall} to={to}>
    {src && (
      <>
        <UseCaseMediaWrapper $isSmall={isSmall}>
          <UseCaseMedia $isSmall={isSmall} $isYoutube={isYoutube} src={src} alt={alt} />
        </UseCaseMediaWrapper>
        <ArticlePdfIconContentSeparator $isSmall={isSmall} />
      </>
    )}
    <UseCaseContentWrapper $isSmall={isSmall}>
      <RecommendedArticleItemCategory component={component}>{category}</RecommendedArticleItemCategory>
      <RecommendedArticleItemTitle $isSmall={isSmall}>{title}</RecommendedArticleItemTitle>
    </UseCaseContentWrapper>
  </UseCaseComponentWrapper>
)
